import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'util/Constants';

const PublicOverviewInfo = () => {
    const navigate = useNavigate();

    return (
        <div className="bg-gradient-to-br from-blue-50 to-indigo-100 rounded-2xl p-8 mb-8 relative overflow-hidden">
            {/* Glass effect overlay */}
            <div className="absolute inset-0 bg-my-blue/10 backdrop-blur-sm rounded-2xl"></div>

            <div className="relative z-10 max-w-4xl mx-auto text-center">
                <div className="mb-6">
                    {/* <h1 className="text-4xl font-bold text-gray-900 mb-4">Access the largest overview of listings in Mallorca</h1> */}
                    <h1 className="text-4xl font-bold text-gray-900 mb-4">All listings in Mallorca from 950+ real estate agents in one place</h1>
                    {/* <p className="text-xl text-gray-700 mb-6">
                        Join thousands of real estate professionals using our platform {'—>'} Built for buyers and agents. Simple, transparent & powerful.
                    </p> */}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                    <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6 shadow-sm border border-white/20">
                        <div className="text-3xl mb-3">🏠</div>
                        <h3 className="text-lg font-semibold text-gray-900 mb-2">Largest Database</h3>
                        <p className="text-gray-600 text-sm">80,000+ listings from 950+ RE agents. Including hidden gems.</p>
                    </div>
                    <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6 shadow-sm border border-white/20">
                        <div className="text-3xl mb-3">🤖</div>
                        <h3 className="text-lg font-semibold text-gray-900 mb-2">Smart Filters + AI Search</h3>
                        <p className="text-gray-600 text-sm">Advanced filters and AI text search focused on your specific search criteria</p>
                    </div>
                    <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6 shadow-sm border border-white/20">
                        <div className="text-3xl mb-3">📋</div>
                        <h3 className="text-lg font-semibold text-gray-900 mb-2">Shareable Collections</h3>
                        <p className="text-gray-600 text-sm">Create and share property collections with you in control about what the receiving end can see</p>
                    </div>
                </div>

                <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                    <button
                        onClick={() => navigate(ROUTES.SIGN_UP)}
                        className="bg-my-blue hover:bg-blue-700 text-white font-semibold py-3 px-8 rounded-xl transition-colors text-lg shadow-lg"
                    >
                        Start Free Trial
                    </button>
                    <button
                        onClick={() => navigate(ROUTES.SIGN_IN)}
                        className="border border-my-blue text-my-blue hover:bg-blue-50 font-semibold py-3 px-8 rounded-xl transition-colors text-lg bg-white/80 backdrop-blur-sm"
                    >
                        Sign In
                    </button>
                </div>

                <div className="mt-6 text-sm text-gray-600">
                    <p>Built for buyers and agents. Simple, transparent & powerful.</p>
                </div>
            </div>
        </div>
    );
};

export default PublicOverviewInfo;
